import './RoundIconButton.module.scss';

// A round 48px button holding one icon, for small choices made over and over
// (Gear List answers, steppers). label names it for screen readers and, with
// showLabel, appears under it too. pressed marks a chosen answer, filled in
// its tone: 'success' (teal), 'danger' (rust) or 'brand' (forest).
const RoundIconButton = ({
  icon,
  label,
  showLabel = false,
  pressed,
  tone = 'brand',
  disabled = false,
  onClick,
}) => (
  <button
    type="button"
    className={`ts-round ts-round--${tone}`}
    aria-label={showLabel ? undefined : label}
    aria-pressed={pressed}
    disabled={disabled}
    onClick={onClick}
  >
    <span className="ts-round__disc" aria-hidden="true">
      {icon}
    </span>
    {showLabel && <span className="ts-round__label">{label}</span>}
  </button>
);

export default RoundIconButton;
